import { useEffect  } from "react";

// useScrollToBottom: Custom hook que maneja el scroll al fondo de un contenedor.
const useScrollToBottom = (containerRef, session, loadingChat, setLoadingChat) => {

    useEffect(() => {
        
        const timer = setTimeout(() => {
            const handleScrollToBottom = () => { // Función para scrollear al final del contenedor de sesiones
                if (containerRef.current) {
                    console.log("ahora voy a scrollear********", containerRef, session)
                    containerRef.current.scrollTop = containerRef.current.scrollHeight;
                    if(loadingChat) setLoadingChat(false);
                }
            };
            handleScrollToBottom(); // Scrollear al final del contenedor cada vez que cambie el contenido
  
        }, 500); 

        return () => clearTimeout(timer);

        
    }, [containerRef, session]);

};

export default useScrollToBottom;

